module.exports = __webpack_public_path__ + "img/warningBoxBG.bcd74cba.png";